import { API_URL } from '../../constants';
import { TAsyncThunk } from '../../../spa/store/types';
import { postRequest } from '../../utils/requestService';
import { EVocabularyPhraseSaveType } from '../../../spa/types/common';

export const PHRASE_CREATION_URL = API_URL + '/phrases/copy';

export const copyPhrasesRest = (
  videoId: string,
  srcGroupId: number,
  targetGroupId: number,
  saveType?: EVocabularyPhraseSaveType
): TAsyncThunk => async(
  dispatch
) => {
  return await dispatch(postRequest(PHRASE_CREATION_URL, {videoId, srcGroupId, targetGroupId, saveType}));
};
